export default (isDropdown) => ({
    state: false,
    isDropdown,
    trigger() {
        this.state = !this.state;
    },
    onClick(e) {
        //e.preventDefault();
        this.trigger();
    },
    onMouseEnter() {
        if (!this.$store.responsive.isMobile) {
            this.state = true;
        }
    },
    onMouseLeave() {
        if (!this.$store.responsive.isMobile) {
            this.state = false;
        }
    },
    init() {

    }
})